var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixLoyaltyV1LoyaltyEarningRule from '@wix/ambassador-loyalty-v1-loyalty-earning-rule/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var Status;
(function (Status) {
    /** Status is unknown or not specified. */
    Status["UNKNOWN"] = "UNKNOWN";
    /** Earning rule is active and can assign points. */
    Status["ACTIVE"] = "ACTIVE";
    /** Earning rule is paused and cannot assign points. */
    Status["PAUSED"] = "PAUSED";
})(Status || (Status = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _bulkCreateLoyaltyEarningRulesRequest = {};
const _bulkCreateLoyaltyEarningRulesResponse = {};
const _createLoyaltyEarningRuleRequest = {};
const _createLoyaltyEarningRuleResponse = {};
const _deleteAutomationEarningRuleRequest = {};
const _deleteAutomationEarningRuleResponse = {};
const _deleteLoyaltyEarningRuleRequest = {};
const _deleteLoyaltyEarningRuleResponse = {};
const _getAutomationEarningRuleRequest = {};
const _getAutomationEarningRuleResponse = {};
const _getLoyaltyEarningRuleRequest = {};
const _getLoyaltyEarningRuleResponse = {};
const _listEarningRulesInTierRequest = {};
const _listEarningRulesInTierResponse = {};
const _listEarningRulesRequest = {};
const _listEarningRulesResponse = {};
const _updateLoyaltyEarningRuleRequest = {};
const _updateLoyaltyEarningRuleResponse = {};
/**
 * Creates a non-automated earning rule.
 *
 * >**Note**: You can only create non-automated earning rules from a supported list.
 * For the supported list of services, see the [introduction](https://dev.wix.com/docs/rest/crm/loyalty-program/earning-rules/introduction#non-automated-earning-rules).
 * @param earningRule - Earning rule to create.
 * @public
 * @documentationMaturity preview
 * @requiredField earningRule
 * @requiredField earningRule.sourceAppId
 * @requiredField earningRule.status
 * @requiredField earningRule.title
 * @requiredField earningRule.triggerActivityType
 * @requiredField earningRule.triggerAppId
 * @adminMethod
 * @returns Created earning rule.
 */
export function createLoyaltyEarningRule(earningRule) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { earningRule: '$[0]' };
        const responseTransformation = '$.earningRule';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createLoyaltyEarningRuleRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['earningRule']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createLoyaltyEarningRuleResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['earningRule']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([earningRule]);
        const reqOpts = ambassadorWixLoyaltyV1LoyaltyEarningRule.createLoyaltyEarningRule(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'earningRule',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates multiple non-automated earning rules.
 *
 * >**Note**: You can only create non-automated earning rules from a supported list.
 * For the supported list of services, see the [introduction](https://dev.wix.com/docs/rest/crm/loyalty-program/earning-rules/introduction#non-automated-earning-rules).
 * @param earningRules - Earning rules to create.
 * @public
 * @documentationMaturity preview
 * @requiredField earningRules
 * @requiredField earningRules.sourceAppId
 * @requiredField earningRules.status
 * @requiredField earningRules.title
 * @requiredField earningRules.triggerActivityType
 * @requiredField earningRules.triggerAppId
 * @adminMethod
 */
export function bulkCreateLoyaltyEarningRules(earningRules) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { earningRules: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkCreateLoyaltyEarningRulesRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#earningRules']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkCreateLoyaltyEarningRulesResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#results.item']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([earningRules]);
        const reqOpts = ambassadorWixLoyaltyV1LoyaltyEarningRule.bulkCreateLoyaltyEarningRules(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'earningRules',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a specified non-automated earning rule.
 *
 * To retrieve both automated and non-automated earning rules, use [List Earning Rules](https://dev.wix.com/docs/rest/crm/loyalty-program/earning-rules/list-earning-rules).
 * @param _id - ID of the earning rule to retrieve.
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @returns Retrieved earning rule.
 */
export function getLoyaltyEarningRule(_id) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { id: '$[0]' };
        const responseTransformation = '$.earningRule';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getLoyaltyEarningRuleRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getLoyaltyEarningRuleResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['earningRule']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id]);
        const reqOpts = ambassadorWixLoyaltyV1LoyaltyEarningRule.getLoyaltyEarningRule(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves an automated earning rule.
 *
 * Currently, only `v1` automated earning rules are supported. To get both automated and non-automated earning rules, use [List Earning Rules](https://dev.wix.com/docs/rest/crm/loyalty-program/earning-rules/list-earning-rules).
 * @param _id - ID of the earning rule to retrieve.
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @deprecated
 * @targetRemovalDate 2024-09-01
 */
export function getAutomationEarningRule(_id) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { id: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getAutomationEarningRuleRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getAutomationEarningRuleResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['earningRule']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id]);
        const reqOpts = ambassadorWixLoyaltyV1LoyaltyEarningRule.getAutomationEarningRule(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates an earning rule.
 *
 * Supports partial updates.
 *
 * Revision number, which increments by 1 each time the earning rule is updated. To prevent conflicting changes,
 * the current revision must be passed when updating the earning rule.
 * @param _id - Loyalty earning rule ID.
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField earningRule
 * @adminMethod
 */
export function updateLoyaltyEarningRule(_id, earningRule) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { earningRule: { '*': '$[1]', id: '$[0]' } };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateLoyaltyEarningRuleRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['earningRule']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateLoyaltyEarningRuleResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['earningRule']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, earningRule]);
        const reqOpts = ambassadorWixLoyaltyV1LoyaltyEarningRule.updateLoyaltyEarningRule(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'earningRule',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Deletes a non-automated earning rule.
 *
 * To delete an automated earning rule, use
 * [Delete Automation Earning Rule](https://dev.wix.com/docs/rest/crm/loyalty-program/earning-rules/delete-automation-earning-rule).
 * @param _id - ID of the earning rule to delete.
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @adminMethod
 */
export function deleteLoyaltyEarningRule(_id, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { id: '$[0]', revision: '$[1].revision' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteLoyaltyEarningRuleRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteLoyaltyEarningRuleResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, options]);
        const reqOpts = ambassadorWixLoyaltyV1LoyaltyEarningRule.deleteLoyaltyEarningRule(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Deletes a custom automated earning rule.
 * Pre-installed automated rules can only be disabled, not deleted.
 *
 * To update an earning rule's status instead of deleting it, use
 * [Update Loyalty Earning Rule](https://dev.wix.com/docs/rest/crm/loyalty-program/earning-rules/update-loyalty-earning-rule).
 *
 * To delete a non-automated earning rule, use
 * [Delete Loyalty Earning Rule](https://dev.wix.com/docs/rest/crm/loyalty-program/earning-rules/delete-loyalty-earning-rule).
 * @param _id - ID of the earning rule to delete.
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @adminMethod
 */
export function deleteAutomationEarningRule(_id) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { id: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteAutomationEarningRuleRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteAutomationEarningRuleResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id]);
        const reqOpts = ambassadorWixLoyaltyV1LoyaltyEarningRule.deleteAutomationEarningRule(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of earning rules.
 *
 * Returns both automated and non-automated earning rules.
 *
 * You can filter the results by: `triggerAppId` or `triggerActivityType`
 * @public
 * @documentationMaturity preview
 */
export function listEarningRules(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            triggerAppId: '$[0].triggerAppId',
            triggerActivityType: '$[0].triggerActivityType',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listEarningRulesRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listEarningRulesResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#earningRules']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixLoyaltyV1LoyaltyEarningRule.listEarningRules(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/** @internal
 * @documentationMaturity preview
 */
export function listEarningRulesInTier(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            tierId: '$[0].tierId',
            paging: '$[0].paging',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listEarningRulesInTierRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listEarningRulesInTierResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#earningRules']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixLoyaltyV1LoyaltyEarningRule.listEarningRulesInTier(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=loyalty-v1-loyalty-earning-rule.universal.js.map